<script setup lang="ts">
const props = defineProps<{
  post?: PostItem | null;
}>();

const postItems = computed(() => {
  return (
    props.post?.related?.reduce<PostItem[]>((acc, post) => {
      if (post.related_posts_id) acc.push(post.related_posts_id);
      return acc;
    }, []) || []
  );
});

const { postToGrid } = useGrid();

const gridItems = computed(() =>
  postItems.value.map((post) => postToGrid(post))
);
</script>

<template>
  <section v-if="gridItems.length > 0" class="post-related">
    <div class="post-related__container container">
      <div class="post-related__wrapper flex flex-col items-stretch gap-10">
        <div class="post-related__title">
          <h2
            class="text-[1.75rem] leading-[1.5rem] lg:text-[3.125rem] lg:leading-[2.75rem]"
          >
            <span class="inline">Podobne</span>
            <span class="inline tracking-[0.25rem]">&emsp14;</span>
            <span class="inline font-display tracking-[0.3125rem]"
              >inspiracje</span
            >
          </h2>
        </div>

        <div class="post-related__content">
          <PostGrid :items="gridItems" />
        </div>
      </div>
    </div>
  </section>
</template>
